// extracted by mini-css-extract-plugin
module.exports = {"accordionContainer":"_c788b0","avatars":"_cb148c","accordionTitle":"_e6355e","accordionSummary":"_c32745","root":"_8e69a2","snippetContainer":"_54ef03","snippet":"_27cfc5"};